"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UploadField;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function UploadField(_ref) {
  var _classnames;

  var filename = _ref.filename,
      label = _ref.label,
      size = _ref.size,
      boxed = _ref.boxed,
      hasName = _ref.hasName,
      fullWidth = _ref.fullWidth;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)('file', (_classnames = {}, _defineProperty(_classnames, "is-".concat(size), size), _defineProperty(_classnames, 'is-boxed', boxed), _defineProperty(_classnames, 'has-name', filename), _defineProperty(_classnames, 'is-fullwidth', fullWidth), _classnames))
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "file-label"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "file-input",
    type: "file",
    name: "resume"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "file-cta"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "file-icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-upload"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "file-label"
  }, label)), filename && /*#__PURE__*/_react.default.createElement("span", {
    className: "file-name"
  }, filename)));
}

UploadField.propTypes = {
  filename: _propTypes.default.string,
  label: _propTypes.default.string,
  boxed: _propTypes.default.bool,
  fullwidth: _propTypes.default.bool
};